import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  styles: ``,
  standalone: true,
})
export class HeaderComponent {}
